export const state = {
    email: "", 
    otp: "",
    oldPassword: ""
}

export const mutations = {
    SET_EMAIL (state, payload) {
        state.email = payload;
    },
    SET_OTP (state, payload) {
        state.otp = payload;
    },
    SET_OLDPASS (state, payload) {
        state.oldPassword = payload
    }
}